import { observable } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';
import TinyInputStore from '@src/components/tiny-input/store';
import AntdMessage from '@src/components/antd/message';
import lockAsync from '@src/utils/lock-async';
import captchaHandlerDecorate from '@src/utils/captcha-deco-util';
import { autobind } from 'core-decorators';
import useUnmount from '@src/utils/hooks/use-unmount';
import * as commonRegex from '@src/utils/common-regex';
class CdkModalStore extends BaseModalStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable text_setting = '';

  @observable closeCallback = noop;

  @observable loading = false;

  @observable countDown = 60;

  @observable countDownTimer = null;

  @observable KvSectionStore;

  // 奖励信息
  rewards = [
    {
      name: '优秀战斗记录',
      count: 2,
      icon: require('./images/reward-1.png')
    },
    {
      name: '通用银',
      count: 15000,
      icon: require('./images/reward-2.png')
    }
  ];

  phoneInput = new TinyInputStore();
  codeInput = new TinyInputStore();

  //校验
  validateNumber = () => {
    if (!this.phoneInput.value) {
      AntdMessage.error('手机号不得为空~');
      return false;
    }
    if (!commonRegex.phoneNumber.test(this.phoneInput.value)) {
      AntdMessage.error('请输入正确的手机号~');
      return false;
    }

    return true;
  };

  /**
   * 点击发送验证码
   */
  handleClickCode = () => {
    //校验
    if (!this.validateNumber()) {
      return;
    }

    //防止重复进入验证码发送流程
    if (this.loading || this.countDownTimer) {
      return;
    }

    this.getPhoneCode();
  };

  /**
   * 发送验证码
   * @param authParams
   * @returns {Promise<boolean>}
   */
  @autobind
  @lockAsync()
  @captchaHandlerDecorate('zt')
  getPhoneCode({ ...authParams }) {
    if (this.loading) {
      return;
    }
    this.loading = true;
    clearInterval(this.countDownTimer);
    this.countDownTimer = null;
    this.$ztService
      .getPhoneCode({
        phone: this.phoneInput.value,
        ...authParams
      })
      .then(res => {
        AntdMessage.success('验证码发送成功~');
        this.countDownTimer = setInterval(() => {
          this.countDown--;
          if (this.countDown <= 0) {
            clearInterval(this.countDownTimer);
            this.countDownTimer = null;
            this.countDown = 60;
            this.loading = false;
          }
        }, 1000);
      })
      .catch(err => {
        this.loading = false;
        AntdMessage.error(err?.message);
      });
  }

  //提交
  confirm = () => {
    //未开启CDK兑换
    if (!this.KvSectionStore.openSendCode) {
      this.onClickClose();
      return;
    }

    //校验
    if (!this.validateNumber()) {
      return;
    }

    const phone = (this.phoneInput.value || '').trim();
    const code = (this.codeInput.value || '').trim();

    if (!code) {
      AntdMessage.error('验证码不得为空~');
      return;
    }

    this.KvSectionStore.getCdkCode(phone, code);
  };

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.closeCallback();
    this.clearStyle();
  };

  use() {
    super.use();
    useUnmount(() => {
      clearInterval(this.countDownTimer);
      this.countDownTimer = null;
      this.countDown = 60;
      this.loading = false;
      this.phoneInput.value = '';
      this.codeInput.value = '';
    });
  }
}

export default CdkModalStore;
